import { Button } from "@clockwise/design-system";
import {
  TrialProBadgeType,
  TrialProBadgeWithTooltip,
} from "@clockwise/web-commons/src/ui/trial-pro-badge-with-tooltip";
import { useTracking } from "@clockwise/web-commons/src/util/analytics.util";
import React from "react";
import { useFeatureFlag } from "../../../../launch-darkly";
import { TrackingEvents } from "../../../../util/analytics.util";
import { useUpdateShowMemoryModal } from "../../../chat-plus-calendar/util/MemoryModalContext";
import { useResetConversation } from "../../hooks/useResetConversation";
import DebugModelDropdown from "../../web/DebugModelDropdown";
import { useSetAIError } from "../hooks/AIErrorContext";

export const AIChatToolbar = () => {
  const updateShowMemoryModal = useUpdateShowMemoryModal();
  const track = useTracking();
  const setError = useSetAIError();
  const [onResetConversation, { loading }] = useResetConversation({
    onError: (error) => {
      setError({
        error,
        message: "Error resetting chat conversation",
        userMessage: "Failed to reset the conversation",
        showUserMessage: true,
      });
    },
  });
  const [isOnShowChatDebugInfo] = useFeatureFlag("ShowChatDebugInfo");

  const handleResetConversation = () => {
    track(TrackingEvents.CHAT.RESET_CONVERSATION);
    void onResetConversation();
  };

  const showMemory = () => {
    updateShowMemoryModal(true);
    track(TrackingEvents.CHAT.MEMORY.MEMORY_MODAL_VIEWED);
  };

  return (
    <div className=" cw-bg-default cw-w-full cw-px-4 cw-pb-4 cw-pt-5 cw-flex cw-flex-row cw-items-center cw-justify-between">
      <div className="cw-flex cw-items-center">
        <div className="cw-heading-base cw-font-body cw-font-bold">AI Scheduler</div>
        <div className="cw-ml-1">
          {/* Using UI For Trial Badge for Beta Badge */}
          <TrialProBadgeWithTooltip
            showToolTip
            tooltipType={TrialProBadgeType.AIBeta}
            colorOption="grey"
            badgeText="Beta"
            width={200}
          />
        </div>
      </div>
      <div className="cw-flex cw-items-center cw-gap-2">
        <Button
          size="xsmall"
          disabled={!!loading}
          onClick={handleResetConversation}
          variant="outlined"
        >
          Clear
        </Button>
        <Button size="xsmall" disabled={!!loading} onClick={showMemory} variant="outlined">
          Memory
        </Button>
        {isOnShowChatDebugInfo && <DebugModelDropdown />}
      </div>
    </div>
  );
};
